
/*
 * ADJUST VAR FOR BREACKPOINTS
 */
function breakpoints() {

    viewport = $(window).width();

    if (viewport < sm) {
        // mobile
        packagesQtyInit = 3;
        packagesQtyViewMore = 3;
        packagesQtyInitDestiny = 3;

        outletsQtyInit = 4;
        outletsQtyViewMore = 4;
        outletsQtyInitDestiny = 4;

    } else if (viewport < lg) {
        // tablet
        packagesQtyInit = 3;
        packagesQtyViewMore = 3;
        packagesQtyInitDestiny = 3;

        outletsQtyInit = 4;
        outletsQtyViewMore = 4;
        outletsQtyInitDestiny = 4;

    } else if (viewport < xl) {
        // laptop
        packagesQtyInit = 7;
        packagesQtyViewMore = 8;
        packagesQtyInitDestiny = 3;
        packagesQtyViewMoreDestiny = 4;

        outletsQtyInit = 8;
        outletsQtyViewMore = 8;
        outletsQtyInitDestiny = 8;
        outletsQtyViewMoreDestiny = 8;

    } else if (viewport < gl) {
        // desktop
        packagesQtyInit = 7;
        packagesQtyViewMore = 8;
        packagesQtyInitDestiny = 3;
        packagesQtyViewMoreDestiny = 4;

        outletsQtyInit = 8;
        outletsQtyViewMore = 8;
        outletsQtyInitDestiny = 8;
        outletsQtyViewMoreDestiny = 8;

    } else if (viewport >= gl) {
        // desktop larger
        packagesQtyInit = 7;
        packagesQtyViewMore = 8;
        packagesQtyInitDestiny = 3;
        packagesQtyViewMoreDestiny = 4;

        outletsQtyInit = 8;
        outletsQtyViewMore = 8;
        outletsQtyInitDestiny = 8;
        outletsQtyViewMoreDestiny = 8;
    }
}
